package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.SchoolW500Rounded: ImageVector
    get() {
        if (_schoolW500Rounded != null) {
            return _schoolW500Rounded!!
        }
        _schoolW500Rounded = Builder(name = "SchoolW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(244.63f, 716.02f)
                quadToRelative(-22.63f, -12.43f, -35.3f, -33.68f)
                quadToRelative(-12.68f, -21.25f, -12.68f, -47.12f)
                verticalLineToRelative(-185.31f)
                lineToRelative(-90.74f, -49.89f)
                quadToRelative(-12.5f, -6.81f, -18.18f, -17.03f)
                quadToRelative(-5.69f, -10.21f, -5.69f, -22.7f)
                quadToRelative(0.0f, -12.49f, 5.72f, -22.92f)
                quadToRelative(5.72f, -10.44f, 18.15f, -17.15f)
                lineToRelative(330.83f, -180.18f)
                quadToRelative(10.19f, -5.71f, 21.03f, -8.45f)
                quadToRelative(10.84f, -2.74f, 22.25f, -2.74f)
                reflectiveQuadToRelative(22.23f, 2.74f)
                quadToRelative(10.82f, 2.74f, 21.01f, 8.45f)
                lineToRelative(379.81f, 207.29f)
                quadToRelative(11.36f, 5.74f, 17.61f, 16.66f)
                reflectiveQuadToRelative(6.25f, 23.36f)
                lineTo(926.93f, 640.0f)
                quadToRelative(0.0f, 18.52f, -12.53f, 31.06f)
                quadToRelative(-12.53f, 12.53f, -31.05f, 12.53f)
                quadToRelative(-18.44f, 0.0f, -31.13f, -12.53f)
                quadToRelative(-12.7f, -12.54f, -12.7f, -31.06f)
                verticalLineToRelative(-231.93f)
                lineToRelative(-76.17f, 41.84f)
                verticalLineToRelative(185.31f)
                quadToRelative(0.0f, 25.87f, -12.68f, 47.12f)
                quadToRelative(-12.67f, 21.25f, -35.3f, 33.68f)
                lineTo(523.02f, 819.48f)
                quadToRelative(-10.19f, 5.72f, -21.01f, 8.45f)
                quadToRelative(-10.81f, 2.74f, -22.01f, 2.74f)
                quadToRelative(-11.2f, 0.0f, -22.01f, -2.74f)
                quadToRelative(-10.82f, -2.73f, -21.01f, -8.45f)
                lineTo(244.63f, 716.02f)
                close()
                moveTo(480.0f, 503.22f)
                lineTo(745.15f, 360.0f)
                lineTo(480.0f, 216.78f)
                lineTo(214.85f, 360.0f)
                lineTo(480.0f, 503.22f)
                close()
                moveTo(480.0f, 743.98f)
                lineTo(675.93f, 638.13f)
                verticalLineToRelative(-141.91f)
                lineToRelative(-151.91f, 83.74f)
                quadToRelative(-10.19f, 5.71f, -21.39f, 8.45f)
                quadToRelative(-11.2f, 2.74f, -22.63f, 2.74f)
                reflectiveQuadToRelative(-22.63f, -2.74f)
                quadToRelative(-11.2f, -2.74f, -21.39f, -8.45f)
                lineToRelative(-151.91f, -83.74f)
                verticalLineToRelative(141.91f)
                lineTo(480.0f, 743.98f)
                close()
                moveTo(480.0f, 503.22f)
                close()
                moveTo(480.0f, 634.98f)
                close()
                moveTo(480.0f, 634.98f)
                close()
            }
        }
        .build()
        return _schoolW500Rounded!!
    }

private var _schoolW500Rounded: ImageVector? = null
